const template = `
<div class="bottom-conditions">
	<form>
		<div class="conditions-container jockey-trainer-reduction">
			<h2>%jockey-trainer-conditions%</h2>
			<div class="conditions-inner">
				<div class="rows">

					<div class="row" data-sticky-template="bottom-conditions-jockey-trainer-reduction-row" data-row-uuid="%uuid%">
						<div class="button delete">
							<div class="wrapper">
								<div class="align y x"><div><div class="base-blue"></div></div></div>
								<div class="align y x"><div class="content"><span class="sprite button-minus-small"></span></div></div>
							</div>
						</div>
						<label>%Min%
							<div class="styled-select">
								<select class="number-of-races min-races" name="jockeyTrainerReduction[%row%][minNumberOfRaces]"></select>
								<span class="sprite dropdown"></span>
							</div>
						</label>
						<label class="mr-20">%max%
							<div class="styled-select">
								<select class="number-of-races max-races" name="jockeyTrainerReduction[%row%][maxNumberOfRaces]"></select>
								<span class="sprite dropdown"></span>
							</div>
						</label>
							<div class="chosen-styled-select">
							 <label>%races-won-by%</label>
							  <div class="chosen-select-container">
								  <select multiple class="jockey-trainer-%row% jockey-trainer-reduction" name="jockeyTrainerReduction[%row%][jockey]"></select>
								  <small class="chosen-select-info">%dropdown-selection-instructions%</small>
								</div>
								<!-- <span class="sprite dropdown"></span> -->
							</div>
					</div><!-- ROW -->
				</div>

				<div class="button plus">
					<div class="wrapper">
						<div class="align y x"><div><div class="base-blue"></div></div></div>
						<div class="align y x"><div class="content"><span class="sprite button-plus-small"></span></div></div>
					</div>
				</div>
			</div>
		</div><!-- CONTAINER -->

		<div class="jockey-trainer-conditions-international-track-warning"></div>

		<div class="conditions-container jockey-trainer-conditions-victory-rich %hide%">
			<h2>%jockey-trainer-conditions-victory-rich%</h2>
			<div class="conditions-inner">
				<div class="rows">
					<div class="row" data-sticky-template="bottom-conditions-jockey-trainer-victory-rich-row" data-row-uuid="%uuid%">
					<label>%min%
						<div class="styled-select">
							<select class="number-of-races min-races" name="victoryRich[%row%][minNumberOfRaces]"></select>
							<span class="sprite dropdown"></span>
						</div>
					</label>
					<label class="mr-20">%max%
						<div class="styled-select">
							<select class="number-of-races max-races" name="victoryRich[%row%][maxNumberOfRaces]"></select>
							<span class="sprite dropdown"></span>
						</div>
					</label>
						<label class="mr-20">%jockeys-victory-rich%
								<div class="styled-select">
								<select class="jockey jockey-victory-rich" name="victoryRich[%row%][jockey]"></select>
								<span class="sprite dropdown"></span>
							</div>
						</label>
					</div> <!-- ROW -->
				</div>
			</div>
		</div> <!-- CONTAINER -->

		<div class="conditions-container jockey-trainer-conditions-not-victory-rich %hide%">
			<h2>%jockey-trainer-conditions-not-victory-rich%</h2>
			<div class="conditions-inner">
				<div class="rows">
					<div class="row" data-sticky-template="bottom-conditions-jockey-trainer-not-victory-rich-row" data-row-uuid="%uuid%">
					<label>%min%
						<div class="styled-select">
							<select class="number-of-races min-races" name="notVictoryRich[%row%][minNumberOfRaces]"></select>
							<span class="sprite dropdown"></span>
						</div>
					</label>
					<label class="mr-20">%max%
						<div class="styled-select">
							<select class="number-of-races max-races" name="notVictoryRich[%row%][maxNumberOfRaces]"></select>
							<span class="sprite dropdown"></span>
						</div>
					</label>
						<label class="mr-20">%jockey-trainers-not-victory-rich%
							<div class="styled-select">
								<select class="jockey jockey-not-victory-rich" name="notVictoryRich[%row%][jockey]"></select>
								<span class="sprite dropdown"></span>
							</div>
						</label>
					</div> <!-- ROW -->
				</div>
			</div>
		</div> <!-- CONTAINER -->

		<div class="conditions-container jockey-trainer-conditions-win-percent %hide%">
			<h2>%jockey-trainer-conditions-win-percent%</h2>
			<div class="conditions-inner">
				<div class="rows">
					<div class="row" data-sticky-template="bottom-conditions-jockey-trainer-win-percent-row"  data-row-uuid="%uuid%">
					<div class="button delete">
						<div class="wrapper">
							<div class="align y x"><div><div class="base-blue"></div></div></div>
							<div class="align y x"><div class="content"><span class="sprite button-minus-small"></span></div></div>
						</div>
					</div>
					<label>%min%
						<div class="styled-select">
							<select class="number-of-races min-races" name="percentWins[%row%][minNumberOfRaces]"></select>
							<span class="sprite dropdown"></span>
						</div>
					</label>
					<label class="mr-20">%max%
						<div class="styled-select">
							<select class="number-of-races max-races" name="percentWins[%row%][maxNumberOfRaces]"></select>
							<span class="sprite dropdown"></span>
						</div>
					</label>
					<span class="mr-20">%jockey-trainer-win-percent%</span>
					<label class="">%from% <input type="number" inputmode="numeric" class="from-points" name="percentWins[%row%][winPercentMin]" min="0" max="100"></label>
					<label class="mr-20">%to% <input type="number" inputmode="numeric" class="to-points" name="percentWins[%row%][winPercentMax]" min="0" max="100"></label>
					</div> <!-- ROW -->
				</div>
				<div class="button plus">
					<div class="wrapper">
						<div class="align y x"><div><div class="base-blue"></div></div></div>
						<div class="align y x"><div class="content"><span class="sprite button-plus-small"></span></div></div>
					</div>
				</div>
			</div>
		</div> <!-- CONTAINER -->

		<div class="conditions-container jockey-trainer-conditions-hometrack %hide%">
			<h2>%jockey-trainer-conditions-hometrack%</h2>
			<div class="conditions-inner">
				<div class="rows">
					<div class="row" data-sticky-template="bottom-conditions-jockey-trainer-hometrack-row" data-row-uuid="%uuid%">
						<label>%min%
							<div class="styled-select">
								<select class="number-of-races min-races" name="hometrack[%row%][minNumberOfRaces]"></select>
								<span class="sprite dropdown"></span>
							</div>
						</label>
						<label class="mr-20">%max%
							<div class="styled-select">
								<select class="number-of-races max-races" name="hometrack[%row%][maxNumberOfRaces]"></select>
								<span class="sprite dropdown"></span>
							</div>
						</label>
						<label class="mr-20">%races-won-by%
							<div class="styled-select">
								<select class="jockey jockey-trainer-hometrack" name="hometrack[%row%][jockey]"></select>
								<span class="sprite dropdown"></span>
							</div>
						</label>
					</div><!-- ROW -->
				</div>
			</div>
		</div> <!-- CONTAINER -->

		<input type="submit" class="submit">
	</form>
</div>
`;

export default template;
